<template>
  <div>
    <h1 class="title is-4">
      通話件数カレンダー
    </h1>
    <div class="columns">
      <div class="column is-narrow">
        <label class="label">担当社員</label>
        <div class="control">
          <div class="select">
            <select v-model="queryEmployeeId" @change="getCallCalendars">
              <option :value="null">
                すべて表示
              </option>
              <option v-for="(value, key) in employees" :key="key" :value="key">
                {{ value }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <FullCalendar
      :options="calendarOptions"
    />
  </div>
</template>

<script>

import * as util from '@/Util'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import DailyCalledGraph from './Modal/DailyCalledGraphModal.vue'

export default {
  name: 'CallCalendars',
  components: {
    FullCalendar,
  },
  data() {
    return {
      callCalendars: [],
      employees: [],
      states: [],
      queryEmployeeId: null,

      events: [],

      calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin],
        initialView: 'dayGridMonth',
        locale: 'ja',
        height: 650,

        headerToolbar: {
          start: 'prev,next',
          center: 'title',
          end: '',
        },
        events: [],
        eventTextColor: '#000',
        eventColor: '#fff',
        eventClick: this.showGraphModal,
      },
    }
  },
  watch: {
    queryEmployeeId(newValue) {
      util.setSessionStorage('search.callCalendars.queryEmployeeId', newValue)
    },
  },
  created() {
    let queryEmployeeId = util.getSessionStorage('search.callCalendars.queryEmployeeId')
    if (queryEmployeeId) {
      this.queryEmployeeId = queryEmployeeId
    }
    this.getCallCalendars()
  },
  methods: {
    getCallCalendars: function (onlyCalendar = 0) {
      let params = {
        employee_id: this.queryEmployeeId,
        only_calendar: onlyCalendar,
      }
      this.$http.get('/call-calendars', {params: params}).then(response => {
        this.calendarOptions.events = response.data.call_calendars
        if (typeof response.data.employees != 'undefined') {
          this.employees = response.data.employees
          this.states = response.data.states
        }
      })
    },
    getCallCalendarsOnly: function () {
      this.getCallCalendars(1)
    },
    showGraphModal(info) {
      let name = '全体'
      if (typeof this.employees[this.queryEmployeeId] !== 'undefined') {
        name = this.employees[this.queryEmployeeId]
      }
      this.$buefy.modal.open({
        parent: this,
        component: DailyCalledGraph,
        hasModalCard: true,
        props: {
          title: name + ' - ' +info.event.start.toLocaleString('ja-JP', {
            month: '2-digit',
            day: '2-digit',
          }),
          params: info.event.extendedProps,
          states: this.states
        },
      })
    },
  },
}
</script>


<style scoped>

>>> .fc-daygrid-day-events {
  text-align: center;
}

>>> .fc-event-title.fc-sticky {
  font-size: 18px;
  font-weight: bold;
}

>>> .fc-day-today .fc-event-main {
  background-color: rgba(255, 220, 40, 0.15);
}

</style>